/* tslint:disable */
import {
  Admin,
  Resource,
  Translation
} from '../index';

declare var Object: any;
export interface LanguageInterface {
  "name": string;
  "code": string;
  "dir": string;
  "iconUrl"?: string;
  "id"?: any;
  "adminId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  admin?: Admin;
  resources?: Resource[];
  translations?: Translation[];
}

export class Language implements LanguageInterface {
  "name": string;
  "code": string;
  "dir": string;
  "iconUrl": string;
  "id": any;
  "adminId": any;
  "createdAt": Date;
  "updatedAt": Date;
  admin: Admin;
  resources: Resource[];
  translations: Translation[];
  constructor(data?: LanguageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Language`.
   */
  public static getModelName() {
    return "Language";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Language for dynamic purposes.
  **/
  public static factory(data: LanguageInterface): Language{
    return new Language(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Language',
      plural: 'languages',
      path: 'languages',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "dir": {
          name: 'dir',
          type: 'string'
        },
        "iconUrl": {
          name: 'iconUrl',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "adminId": {
          name: 'adminId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        admin: {
          name: 'admin',
          type: 'Admin',
          model: 'Admin',
          relationType: 'belongsTo',
                  keyFrom: 'adminId',
          keyTo: 'id'
        },
        resources: {
          name: 'resources',
          type: 'Resource[]',
          model: 'Resource',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'languageId'
        },
        translations: {
          name: 'translations',
          type: 'Translation[]',
          model: 'Translation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'languageId'
        },
      }
    }
  }
}
